/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SurfaceEarningRuleItem } from './SurfaceEarningRuleItem';
import {
    SurfaceEarningRuleItemFromJSON,
    SurfaceEarningRuleItemFromJSONTyped,
    SurfaceEarningRuleItemToJSON,
    SurfaceEarningRuleItemToJSONTyped,
} from './SurfaceEarningRuleItem';

/**
 * 
 * @export
 * @interface SurfaceEarningRulesConfig
 */
export interface SurfaceEarningRulesConfig {
    /**
     * Section title (e.g. "How to Earn Points")
     * @type {string}
     * @memberof SurfaceEarningRulesConfig
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceEarningRulesConfig
     */
    subtitle?: string;
    /**
     * 
     * @type {Array<SurfaceEarningRuleItem>}
     * @memberof SurfaceEarningRulesConfig
     */
    rules?: Array<SurfaceEarningRuleItem>;
    /**
     * Label suffix for points (e.g. "PTS", "XP"). Default "PTS".
     * @type {string}
     * @memberof SurfaceEarningRulesConfig
     */
    pointsLabel?: string;
}

/**
 * Check if a given object implements the SurfaceEarningRulesConfig interface.
 */
export function instanceOfSurfaceEarningRulesConfig(value: object): value is SurfaceEarningRulesConfig {
    return true;
}

export function SurfaceEarningRulesConfigFromJSON(json: any): SurfaceEarningRulesConfig {
    return SurfaceEarningRulesConfigFromJSONTyped(json, false);
}

export function SurfaceEarningRulesConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceEarningRulesConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'subtitle': json['subtitle'] == null ? undefined : json['subtitle'],
        'rules': json['rules'] == null ? undefined : ((json['rules'] as Array<any>).map(SurfaceEarningRuleItemFromJSON)),
        'pointsLabel': json['pointsLabel'] == null ? undefined : json['pointsLabel'],
    };
}

export function SurfaceEarningRulesConfigToJSON(json: any): SurfaceEarningRulesConfig {
    return SurfaceEarningRulesConfigToJSONTyped(json, false);
}

export function SurfaceEarningRulesConfigToJSONTyped(value?: SurfaceEarningRulesConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'subtitle': value['subtitle'],
        'rules': value['rules'] == null ? undefined : ((value['rules'] as Array<any>).map(SurfaceEarningRuleItemToJSON)),
        'pointsLabel': value['pointsLabel'],
    };
}

